/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types */
/* eslint-disable react/no-unused-state */

import UilEllipsisV from '@iconscout/react-unicons/icons/uil-ellipsis-v';
import { Button, Col, Layout, Row } from 'antd';
import propTypes from 'prop-types';
import { Component } from 'react';
import { Scrollbars } from '@pezhmanparsaee/react-custom-scrollbars';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';

import MenueItems from './MenueItems';
import { FooterStyle, LayoutContainer, SmallScreenAuthInfo, TopMenuSearch } from './Style';
import TopMenu from './TopMenu';
import AuthInfo from '../components/utilities/auth-info/info';
import logo from '../assets/logo.svg';
import { getMe } from '../redux/authentication/actions';
import BottomInstructionButton from './BottomInstructionButton';
import { switchRole } from '../redux/user/actions';
import SwitchBackToSuperAdmin from './SwitchBackToSuperAdmin';

const { theme } = require('../config/theme/themeVariables');
const { Header, Sider, Content } = Layout;

const ThemeLayout = (WrappedComponent) => {
  class LayoutComponent extends Component {
    constructor(props) {
      super(props);
      this.state = {
        collapsed: false,
        hide: true,
        searchHide: true,
        customizerAction: false,
        activeSearch: false,
      };
    }

    componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      this.updateDimensions();

      const { isLoggedIn, dispatchGetMe } = this.props;
      if (isLoggedIn) {
        dispatchGetMe();
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }

    updateDimensions = () => {
      this.setState({
        collapsed: window.innerWidth <= 1200,
      });
    };

    handleSwitchBackToAdmin = () => {
      const { dispatch } = this.props;
      dispatch(switchRole({ switch_back: true }));
    };

    render() {
      const { collapsed, hide } = this.state;

      const {
        layoutMode,
        rtl,
        topMenu,
        userRole,
        UsersProfile,
        isLoggedIn,
        isMerchant,
        isSwitched,
        hideSwitchBackToSuperadmin,
        language,
      } = this.props;

      const sidebarOnlyRoles = ['merchant', 'staff', 'sales_agent', 'super_admin'];

      const useSidebar = !topMenu || window.innerWidth <= 991 || sidebarOnlyRoles.includes(userRole);

      const useTopMenu = topMenu && window.innerWidth > 991 && !sidebarOnlyRoles.includes(userRole);

      const left = !rtl ? 'left' : 'right';

      const toggleCollapsed = () => {
        this.setState({ collapsed: !collapsed });
      };

      const toggleCollapsedMobile = () => {
        if (window.innerWidth <= 990) {
          this.setState({ collapsed: !collapsed });
        }
      };

      const onShowHide = () => {
        this.setState({
          hide: !hide,
          searchHide: true,
        });
      };

      const SideBarStyle = {
        margin: '63px 0 0 0',
        padding: `${!rtl ? '20px 20px 55px 0' : '20px 0 55px 20px'}`,
        overflowY: 'auto',
        height: '100vh',
        position: 'fixed',
        [left]: 0,
        zIndex: 988,
      };

      const renderView = ({ style }) => {
        const customStyle = {
          marginRight: 'auto',
          [rtl ? 'marginLeft' : 'marginRight']: '-17px',
        };
        return <div style={{ ...style, ...customStyle }} />;
      };

      const renderThumbVertical = ({ style }) => {
        const thumbStyle = {
          borderRadius: 6,
          backgroundColor: '#F1F2F6',
          [left]: '2px',
        };
        return <div style={{ ...style, ...thumbStyle }} />;
      };

      const renderThumbHorizontal = ({ style }) => {
        const thumbStyle = {
          borderRadius: 6,
          backgroundColor: '#F1F2F6',
        };
        return <div style={{ ...style, ...thumbStyle }} />;
      };

      const link = UsersProfile?.package?.instruction_manual_link;

      return (
        <LayoutContainer>
          <Layout className="layout">
            <Header
              style={{
                position: 'fixed',
                width: '100%',
                top: 0,
                [!rtl ? 'left' : 'right']: 0,
              }}
            >
              <div className="ninjadash-header-content d-flex">
                <div className="ninjadash-header-content__left">
                  <div className="navbar-brand">
                    <Link className={useTopMenu ? 'ninjadash-logo top-menu' : 'ninjadash-logo'} to="/">
                      <img src={logo} alt="logo" />
                    </Link>

                    {useSidebar && (
                      <Button type="link" onClick={toggleCollapsed}>
                        <img
                          src={require(`../static/img/icon/${collapsed ? 'left-bar.svg' : 'left-bar.svg'}`)}
                          alt="menu"
                        />
                      </Button>
                    )}
                  </div>
                </div>

                <div className="ninjadash-header-content__right d-flex">
                  <div className="ninjadash-navbar-menu d-flex align-center-v">{useTopMenu && <TopMenu />}</div>

                  <div className="ninjadash-nav-actions">
                    {useTopMenu ? (
                      <TopMenuSearch>
                        <div className="top-right-wrap d-flex">
                          <span />
                          <AuthInfo />
                        </div>
                      </TopMenuSearch>
                    ) : (
                      <AuthInfo />
                    )}
                  </div>
                </div>

                <div className="ninjadash-header-content__mobile">
                  <div className="ninjadash-mobile-action">
                    <Link className="btn-auth" onClick={onShowHide} to="#">
                      <UilEllipsisV />
                    </Link>
                  </div>
                </div>
              </div>
            </Header>

            <div className="ninjadash-header-more">
              <Row>
                <Col md={0} sm={24} xs={24}>
                  <SmallScreenAuthInfo hide={hide}>
                    <AuthInfo rtl={rtl} />
                  </SmallScreenAuthInfo>
                </Col>
              </Row>
            </div>

            <Layout>
              {useSidebar && (
                <ThemeProvider theme={theme}>
                  <Sider
                    width={280}
                    style={SideBarStyle}
                    collapsed={collapsed}
                    theme={layoutMode === 'lightMode' ? 'light' : 'dark'}
                  >
                    <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                      <div style={{ flex: 1, overflow: 'hidden' }}>
                        <Scrollbars
                          autoHide
                          renderThumbHorizontal={renderThumbHorizontal}
                          renderThumbVertical={renderThumbVertical}
                          renderView={renderView}
                        >
                          <MenueItems
                            topMenu={topMenu && !sidebarOnlyRoles.includes(userRole)}
                            toggleCollapsed={toggleCollapsedMobile}
                          />
                        </Scrollbars>
                      </div>

                      {link && userRole === 'merchant' && (
                        <div style={{ padding: '5px' }}>
                          <BottomInstructionButton />
                        </div>
                      )}

                      <div style={{ padding: '5px' }}>
                        {isLoggedIn && isMerchant && isSwitched === true && !hideSwitchBackToSuperadmin && (
                          <SwitchBackToSuperAdmin />
                        )}
                      </div>
                    </div>
                  </Sider>
                </ThemeProvider>
              )}

              <Layout className="atbd-main-layout">
                <Content>
                  <WrappedComponent {...this.props} />
                  <FooterStyle className="admin-footer">
                    <Row>
                      <Col md={12} xs={24} />
                      <Col md={12} xs={24} />
                    </Row>
                  </FooterStyle>
                </Content>
              </Layout>
            </Layout>
          </Layout>

          {window.innerWidth <= 991 && (
            <span className={collapsed ? 'ninjadash-shade' : 'ninjadash-shade show'} onClick={toggleCollapsed} />
          )}
        </LayoutContainer>
      );
    }
  }

  const mapStateToProps = (state) => {
    const userRole = state?.auth?.user?.role || state?.auth?.me?.user?.roles?.[0] || state?.auth?.me?.roles?.[0];

    return {
      layoutMode: state.ChangeLayoutMode.mode,
      rtl: state.ChangeLayoutMode.rtlData,
      topMenu: state.ChangeLayoutMode.topMenu,
      userRole,
      isLoggedIn: state?.auth?.login,
      language: state?.auth?.language,
      UsersProfile: state?.auth?.me,
      isMerchant: userRole === 'merchant', // ✅ FIXED
      isSwitched: state?.user?.isSwitched,
      hideSwitchBackToSuperadmin:
        typeof window !== 'undefined' && window.location.pathname.includes('administrative_billing_details_submitted'),
    };
  };

  const mapDispatchToProps = {
    dispatchGetMe: getMe,
  };

  LayoutComponent.propTypes = {
    layoutMode: propTypes.string,
    rtl: propTypes.bool,
    topMenu: propTypes.bool,
    userRole: propTypes.string,
    isLoggedIn: propTypes.bool,
    dispatchGetMe: propTypes.func,
    language: propTypes.object,
  };

  return connect(mapStateToProps, mapDispatchToProps)(LayoutComponent);
};

export default ThemeLayout;
